export enum OrderAccessRoleLabel {
  MANAGER = 'Editor',
  VIEWER = 'Viewer',
}

interface RoleAction {
  id: string;
  label: string;
  description?: string;
}

export enum OrderAccessRole {
  MANAGER = 'MANAGER',
  VIEWER = 'VIEWER',
}

export const ROLE_ACTIONS: Record<App.OrderAccessRole, Array<RoleAction>> = {
  MANAGER: [
    { id: 'upgrade', label: 'Upgrade rooms' },
    { id: 'cancel', label: 'Cancel the booking' },
    { id: 'change-dates', label: 'Change booking dates' },
  ],
  VIEWER: [
    { id: 'view', label: 'Only view booking details', description: 'They cannot perform any self-service actions' },
  ],
};
